export const validateCharCount = (currentCount: number, maxCount: number) =>
  currentCount <= maxCount
